import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../Context/LanguageContext';

const Navbar = () => {
    const { t, toggleLanguage, language } = useLanguage();
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    // Lock body scroll when mobile menu is open
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    // Close menu on route change
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    // Determine active section for hash-based nav on home page
    const [activeSection, setActiveSection] = useState('');
    
    const updateActiveSection = useCallback(() => {
        if (location.pathname !== '/') {
            setActiveSection('');
            return;
        }
        const sections = ['header', 'hakkimizda', 'etkinlikler', 'yonetimKurulu', 'contact'];
        let current = '';
        for (const id of sections) {
            const el = document.getElementById(id);
            if (el) {
                const rect = el.getBoundingClientRect();
                if (rect.top <= 100) {
                    current = id;
                }
            }
        }
        setActiveSection(current);
    }, [location.pathname]);

    useEffect(() => {
        if (location.pathname !== '/') return;
        window.addEventListener('scroll', updateActiveSection, { passive: true });
        updateActiveSection();
        return () => window.removeEventListener('scroll', updateActiveSection);
    }, [location.pathname, updateActiveSection]);

    const isActive = (href) => {
        // For sub-page links
        if (href.startsWith('/') && !href.startsWith('/#')) {
            return location.pathname === href;
        }
        // For hash links on home page
        if (href.startsWith('/#') && location.pathname === '/') {
            const sectionId = href.replace('/#', '');
            return activeSection === sectionId;
        }
        return false;
    };

    const closeMenu = () => setMenuOpen(false);

    return (
        <nav id="nav-wrap" className={menuOpen ? 'menu-open' : ''}>
            <button
                className="mobile-btn"
                onClick={() => setMenuOpen(!menuOpen)}
                title={menuOpen ? 'Hide navigation' : 'Show navigation'}
                aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={menuOpen}
            >
                {menuOpen ? 'Hide navigation' : 'Show navigation'}
            </button>

            <ul id="nav" className="nav">
                <li className={isActive('/#header') ? 'current' : ''}><a href="/#header" onClick={closeMenu}>{t('navbar.home')}</a></li>
                <li className={isActive('/#hakkimizda') ? 'current' : ''}><a href="/#hakkimizda" onClick={closeMenu}>{t('navbar.about')}</a></li>
                <li className={isActive('/#etkinlikler') ? 'current' : ''}><a href="/#etkinlikler" onClick={closeMenu}>{t('navbar.events')}</a></li>
                <li className={isActive('/#yonetimKurulu') ? 'current' : ''}><a href="/#yonetimKurulu" onClick={closeMenu}>{t('navbar.team')}</a></li>
                <li className={isActive('/#contact') ? 'current' : ''}><a href="/#contact" onClick={closeMenu}>{t('navbar.contact')}</a></li>
                <li className={isActive('/members') ? 'current' : ''}><Link to="/members" onClick={closeMenu}>{t('navbar.map')}</Link></li>
                <li className={isActive('/announcements') ? 'current' : ''}><Link to="/announcements" onClick={closeMenu}>{t('navbar.announcements')}</Link></li>
                <li className={isActive('/jobs') ? 'current' : ''}><Link to="/jobs" onClick={closeMenu}>{t('navbar.jobs')}</Link></li>
                <li className={isActive('/reports') ? 'current' : ''}><Link to="/reports" onClick={closeMenu}>{t('navbar.reports')}</Link></li>
                <li className="theme-toggle-li">
                    <button onClick={toggleLanguage} className="theme-toggle-btn" aria-label="Toggle Language">
                        {language === 'tr' ? 'EN' : 'TR'}
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default Navbar;
